import React from 'react';
import {useToken} from '@chakra-ui/react';
import LogoSvg from '../assets/images/Logo.svg';

export const Logo = (props) => {
    const {iconColor = 'currentColor'} = props;
    const color = useToken('colors', iconColor);
    return <img src={LogoSvg} style={{color: color}} alt="venrock-logo"/>;
};
